import { Bracket } from "@portal-frontend-ssr/blast-api/src/tournament/types/Bracket";
import { ClientOnly } from "remix-utils/client-only";
import { Accordion, ContentWrapper, Header, Icon } from "~/shared/components/Accordion";
import { SwissBracketComponent } from "~/shared/components/Brackets/components/SwissBracket/SwissBracketComponent";
import { getDateRangeLabel } from "../../helpers/getDateRangeLabel";
import { GenericPlayoffBracket } from "../PlayoffBracket/PlayoffBracketComponents/GenericPlayoffBracket";
interface SwissBracketProps {
  bracket: Bracket;
  shouldBracketBeExpanded: boolean;
}

export const SwissBracket = ({ bracket, shouldBracketBeExpanded }: SwissBracketProps) => {
  return (
    <Accordion className="!m-0" isExpandedByDefault={shouldBracketBeExpanded}>
      <Header className="hover:bg-background-85">
        {/* Bracket Header (ex. Group A...) */}
        <div className="flex flex-row items-center gap-5">
          <span className="text-white font-style-label-l4">{bracket.label}</span>
          <div className="flex h-4 items-center justify-center rounded-small bg-white px-2">
            <ClientOnly fallback={<div className="w-16" />}>
              {() => (
                <span className="text-background-100 font-style-label-l4">
                  {getDateRangeLabel({ startDate: bracket.startDate, endDate: bracket.endDate })}
                </span>
              )}
            </ClientOnly>
          </div>
        </div>
        <Icon isTertiary />
      </Header>
      <ContentWrapper>
        <div className="pt-3">
          <SwissBracketComponent bracket={bracket} />
        </div>
        {bracket.matches?.length ? (
          <div className="flex w-full place-content-center">
            <GenericPlayoffBracket
              tournamentId={bracket.tournamentUuid}
              stageId={bracket.tournamentUuid}
              gameId={"cs"}
              bracket={bracket}
            />
          </div>
        ) : null}
      </ContentWrapper>
    </Accordion>
  );
};
